import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, ORM } from 'utility-ts-orm';
import { PathTopic } from '../builders/path_topic_builder';

angular
  .module('data-ng-todos')
  .factory(
    'updateTopicOptInsCommand',
    function updateTopicOptInsCommandDefinition(
      $q: ng.IQService,
      defineCommand: IDefineCommand,
      topicToggleOptedInCommand: ICommand,
      log: any
    ) {
      return defineCommand(
        'updateTopicOptInsCommand',
        function updateTopicOptInsCommand(deferred: ng.IDeferred<IQuery[]>, updatedTopics: PathTopic[]) {
          const updateTopicPromises = _4.map(updatedTopics, (topic) => {
            return topicToggleOptedInCommand(topic);
          });

          $q.all(updateTopicPromises)
            .then(() => {
              log.user.success(`Successfully updated your To-Do topic selections`);
              deferred.resolve();
            })
            .catch(() => {
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/update_topic_opt_ins_command.ts